module.exports = __webpack_public_path__ + "static/media/spray.8e74bc90.png";